/* eslint-disable @typescript-eslint/no-var-requires */
import flatten from 'flat';
import { createIntlCache } from 'react-intl';

/**
 * Convenience passthrough to react-intl's own createIntlCache. According to their docs, this is to prevent memory leaks.
 */
export const cache = createIntlCache();

/**
 * Constant. List of supported locales used at Healthvana.
 */
export const supportedLocales = ['en-US', 'es'];

/**
 * Helper function to get the needed locale messages.
 * @param {string} appName Should match the folder / location of the Translation file.
 * @param {string} [locale='en-US'] Locale to use.
 * @returns {Promise} Asynchronously resolves to the JSON object needed to support the given locale. If that locale cannot be found, resolves to the default (en-US).
 */
export const importMessages = (appName, locale = 'en-US') => {
    if (!appName) {
        throw new Error(
            'Application name must be supplied to import messages!'
        );
    }

    try {
        // relative because *shakes fist at jest*
        const messages = flatten(
            require(`../Translations/${appName}/${locale}.json`)
        );
        return messages;
    } catch (e) {
        console.error(
            `Failed to set ${locale} messages for ${appName} - loading en-US as fallback`
        );
        return importMessages(appName);
    }
};

/**
 *
 * @param {object} strings Strings for morning, afternoon, evening
 * @returns {string} Returns the correct greeting for the time of day.
 */
export function multilingualGreeting(
    strings = {
        morning: 'Good morning',
        afternoon: 'Good afternoon',
        evening: 'Good evening'
    }
) {
    let d = new Date(Date.now()); // use date.now to facilitate mocking.
    let hours = d.getHours();
    if (hours < 12) return strings.morning;
    if (hours >= 12 && hours < 17) return strings.afternoon;
    return strings.evening;
}
